import routerOptions0 from "/home/runner/work/octo/octo/node_modules/.pnpm/nuxt@3.2.0_dq2illufn2sdyxstnqbjq3sy6i/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: true
}
export default {
...configRouterOptions,
...routerOptions0,
}